import React, { useRef, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

import {
  customerCategoryCellRenderer,
  setCountries,
  setSiteCategories,
  setStates,
  stateCellRenderer,
  setUsers,
  userCellRenderer,
} from "../../../../component/cellRenderers/renderers";
import SideNav from "../../../../component/layouts/sideNav";
import {
  setAlertConfirmDeletion,
  setAlertTitleText,
} from "../../../../component/modal/alertModal";

import {
  PRUSSIAN_BLUE,
  SPANISH_GREEN,
  WHITE,
} from "../../../../resources/constant/colors/theme";
import {
  ADD,
  DELETE,
  MASTER,
  SITE,
} from "../../../../resources/constant/strings/string";
import { PATH_SITE } from "../../../../resources/constant/url/url";

import { APIMASTER } from "../../../../apihandler/master";

import Modal from "./modal";


export default function Site() {

  const gridRef = useRef();

  const [selectedRowId, setSelectedRowId] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const deleteModel = () => {
    if (selectedRowIds.length === 0) {
      return;
    }
    setAlertConfirmDeletion(
      "Confirmation needed",
      `Do you confirm on proceeding to delete ${selectedRowIds.length} record(s)?`
    ).then((consent) => {
      if (!consent.isConfirmed) return;

      console.log("delete the selected ids: ", selectedRowIds);
      APIMASTER.DeleteSites(selectedRowIds)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.statusCode === 204) {
            const selectedData = gridRef.current.api.getSelectedRows();
            gridRef.current.api.applyTransaction({ remove: selectedData });
            setAlertTitleText("Success", "The record was deleted successfully");
            setOpenModal(false);
          } else {
            setAlertTitleText(
              "Oops...",
              `Something went wrong...${data.message}`
            );
            setOpenModal(false);
          }
        });
    });
  };

  const updateModel = (model) => {
    gridRef.current.api.applyTransaction({ update: [model] });
  };

  const addModel = (model) => {
    gridRef.current.api.applyTransaction({ add: [model], addIndex: 0 });
  };

  const onRowSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    if (selectedRows.length > 0) {
      setSelectedRowId(selectedRows[0].id);
      const ids = selectedRows.map((row) => row.id);
      setSelectedRowIds(ids);
    } else {
      setSelectedRowId(0);
      setSelectedRowIds([]);
    }
  };

  let initialValue = {};

  const setInitialValueForAdd = () => {
    initialValue = {
      id: 0,
      customerCode: "Auto Generated",
      customerName: "",
      prefix: "",
      categoryId: 0,
      address1: "",
      address2: "",
      address3: "",
      city: "",
      countryId: 0,
      stateId: 0,
      pin: "",
      email: "",
      phone: "",
      mobile: "",
      panNo: "",
      gstn: "",
      cst: "",
      contactPerson: "",
      woPrefix: "",
      isStore: 0,
      accountId: null,
    };
  };

  const [formTitle, setFormTitle] = useState("Add Site");
  const handleEditData = (oldData) => {
    console.log(oldData);
    initialValue = {
      id: oldData.id,
      customerCode: oldData.customerCode,
      customerName: oldData.customerName,
      prefix: oldData.prefix,
      categoryId: oldData.categoryId || 0,
      address1: oldData.address1,
      address2: oldData.address2,
      address3: oldData.address3,
      city: oldData.city,
      countryId: oldData.countryId || 0,
      stateId: oldData.stateId || 0,
      pin: oldData.pin,
      email: oldData.email,
      phone: oldData.phone,
      mobile: oldData.mobile,
      panNo: oldData.panNo,
      gstn: oldData.gstn,
      cst: oldData.cst,
      contactPerson: oldData.contactPerson,
      woPrefix: oldData.woPrefix,
      isStore: oldData.isStore,
      accountId: oldData.accountId,
    };

    setFormData(initialValue);
    setViewOnlyModel(false);
    setFormTitle("Edit Sites");
    setOpenModal(true);
  };

  const handleViewData = (oldData) => {
    console.log(oldData);
    initialValue = {
      id: oldData.id,
      customerCode: oldData.customerCode,
      customerName: oldData.customerName,
      prefix: oldData.prefix,
      categoryId: oldData.categoryId || 0,
      address1: oldData.address1,
      address2: oldData.address2,
      address3: oldData.address3,
      city: oldData.city,
      countryId: oldData.countryId || 0,
      stateId: oldData.stateId || 0,
      pin: oldData.pin,
      email: oldData.email,
      phone: oldData.phone,
      mobile: oldData.mobile,
      panNo: oldData.panNo,
      gstn: oldData.gstn,
      cst: oldData.cst,
      contactPerson: oldData.contactPerson,
      woPrefix: oldData.woPrefix,
      isStore: oldData.isStore,
      accountId: oldData.accountId,
    };

    setFormData(initialValue);
    setViewOnlyModel(true);
    setFormTitle("View Sites");
    setOpenModal(true);
  };

  const columnDefs = [
    {
      flex: 1.2,
      headerName: "Site Code",
      field: "customerCode",
      checkboxSelection: false,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      flex: 1.5,
      headerName: "Site Name",
      field: "customerName",
      autoHeight: true,
      wrapText: true,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Prefix",
      field: "prefix",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Category",
      field: "categoryId",
      valueGetter: (params) => {
        return customerCategoryCellRenderer({ value: params.data.categoryId });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },

    {
      headerName: "City",
      field: "city",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      autoHeight: true,
      wrapText: true,
    },
    {
      headerName: "State",
      field: "stateId",
      valueGetter: (params) => {
        return stateCellRenderer({ value: params.data.stateId });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Modified By",
      field: "modifiedBy",
      valueGetter: (params) => {
        return userCellRenderer({ value: params.data.modifiedBy });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      autoHeight: true,
      wrapText: true,
    },

    {
      flex: 0.8,
      headerName: "Actions",
      field: "id",
      sortable: false,
      filter: false,
      floatingFilter: false,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <IconButton
            aria-label="edit"
            onClick={() => {
              handleEditData(params.data);
            }}
          >
            <EditIcon style={{ color: PRUSSIAN_BLUE, width: "20px" }} />
          </IconButton>
          <IconButton
            aria-label="visibility"
            onClick={() => {
              handleViewData(params.data);
            }}
          >
            <VisibilityIcon style={{ color: PRUSSIAN_BLUE, width: "20px" }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    editable: false,
    flex: 1,
    filter: "agTextColumnFilter",
    filterParams: {
      caseSensitive: false,
      defaultOption: "startsWith",
    },
    floatingFilter: true,
  };

  const onGridReady = (params) => {
    APIMASTER.States()
      .then((resp) => resp.json())
      .then((resp) => {
        setStates(resp.response);
      });
    APIMASTER.Countries()
      .then((resp) => resp.json())
      .then((resp) => {
        setCountries(resp.response);
      });
    APIMASTER.SiteCategories()
      .then((resp) => resp.json())
      .then((resp) => {
        setSiteCategories(resp.response);
      })
      .then((resp) => {
        APIMASTER.Sites()
          .then((resp) => resp.json())
          .then((resp) => {
            if (resp.statusCode !== 200) {
              setAlertTitleText("Oops..", `An error occurred ${resp.message}`);
              return;
            }
            const data = resp.response.sort((a, b) => b.id - a.id);
            params.api.applyTransaction({ add: data });
          });
      });

    APIMASTER.UserOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setUsers(resp.response);
      });
  };

  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState(initialValue);
  const [viewOnlyModel, setViewOnlyModel] = useState(false);

  return (
    <SideNav
      currentComponent={MASTER}
      subComponent={SITE}
      subComponentPath={PATH_SITE}
      detailComponent=""
    >
      {openModal && (
        <Modal
          style={{ align: "center" }}
          setOpenModal={setOpenModal}
          updateModel={updateModel}
          addModel={addModel}
          viewModel={viewOnlyModel}
          model={formData}
          formTitle={formTitle}
        ></Modal>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: 10,
          marginRight: 10,
        }}
      >
        <Button
          style={{
            backgroundColor: SPANISH_GREEN,
            textTransform: "capitalize",
            fontSize: 14,
            color: WHITE,
            minWidth: "180px",
            minHeight: "45px",
          }}
          onClick={() => {
            setInitialValueForAdd();
            setFormData(initialValue);
            setFormTitle("Add Sites");
            setViewOnlyModel(false);
            setOpenModal(true);
          }}
        >
          {ADD}
        </Button>

        <Button
          onClick={() => {
            deleteModel();
          }}
          variant="outlined"
          sx={{
            borderColor: SPANISH_GREEN,
          }}
          style={{
            //backgroundColor: SPANISH_GREEN,
            textTransform: "capitalize",
            fontSize: 14,
            color: SPANISH_GREEN,
            minWidth: "180px",
            minHeight: "45px",
            marginRight: 10,
          }}
        >
          {DELETE}
        </Button>
      </div>

      <div className="App">
        <div className="ag-theme-alpine" style={{ height: "570px" }}>
          <AgGridReact
            copyGroupHeadersToClipboard={true}
            enableRangeSelection={true}
            columnDefs={columnDefs}
            ref={gridRef}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            paginationAutoPageSize={true}
            pagination={true}
            rowSelection="multiple"
            getRowId={(params) => params.data.id}
            onSelectionChanged={onRowSelectionChanged}
          ></AgGridReact>
        </div>
      </div>
    </SideNav>
  );
}
